import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f0a0b8f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "deck" }
const _hoisted_2 = ["onMouseenter"]
const _hoisted_3 = { class: "minicard-title" }
const _hoisted_4 = { class: "minicard-stats" }

import { Card } from "@/types/index"
  import CardPreview from "@/components/CardPreview.vue"
  import { ref, reactive, computed } from "vue"

  
export default /*#__PURE__*/_defineComponent({
  props: {
    deck: null,
    hoveredStatValue: null,
    hoveredStatName: null
  },
  setup(__props: any) {

const props = __props as {
    deck: Card[]
    hoveredStatValue: number | null
    hoveredStatName: string | null
  }

  

  function minicardClass(type: string, statA: number, statB: number) {
    let classList = [type]
    if (statA === props.hoveredStatValue && props.hoveredStatName === "statA") {
      classList.push("minicard-hovered")
    }
    if (statB === props.hoveredStatValue && props.hoveredStatName === "statB") {
      classList.push("minicard-hovered")
    }
    return classList
  }

  const cardPreviewData = ref({
    id: "",
    name: "",
    type: "",
    text: "",
    statA: 0,
    statB: 0,
    image: "",
  })

  const cardPreviewDisplayed = ref(false)
  const cardPreviewOffset = reactive({
    x: 0,
    y: 0,
  })

  const previewOffsetStyle = computed(
    () =>
      `transform: translate(${cardPreviewOffset.x}px,${cardPreviewOffset.y}px)`
  )

  function computePreviewOffset(
    itemIndex: number,
    itemHeight = 60,
    previewHeight = 320,
    additionalHeight = 80
  ): { x: number; y: number } {
    // use <html>.clientHeight instead of window to account for scrollbars
    const windowHeight = document.children[0].clientHeight
    let computedHeight =
      itemIndex * itemHeight + previewHeight + additionalHeight
    const x =
      document.children[0].scrollWidth - document.children[0].clientWidth
    if (computedHeight < windowHeight) {
      return {
        x,
        y: itemIndex * itemHeight,
      }
    }
    // if preview would render outside the window then place it at the bottom
    else {
      return {
        x,
        y: 0,
      }
    }
  }

  function displayCardPreview(card: Card) {
    cardPreviewData.value = card
    cardPreviewDisplayed.value = true
    const pickedIndex = props.deck.findIndex((el) => el.id === card.id)
    const offset = computePreviewOffset(pickedIndex)
    cardPreviewOffset.x = offset.x
    cardPreviewOffset.y = offset.y
  }

  function hideCardPreview() {
    cardPreviewDisplayed.value = false
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, { name: "fade" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.deck, (card) => {
          return (_openBlock(), _createElementBlock("div", {
            key: card.id,
            class: _normalizeClass(["minicard", minicardClass(card.type, card.statA, card.statB)]),
            onMouseenter: ($event: any) => (displayCardPreview(card)),
            onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (hideCardPreview()))
          }, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(card.name), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(card.statA) + " / " + _toDisplayString(card.statB), 1)
          ], 42, _hoisted_2))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "preview" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: "hover-preview",
          style: _normalizeStyle(_unref(previewOffsetStyle))
        }, [
          _createVNode(CardPreview, { card: cardPreviewData.value }, null, 8, ["card"])
        ], 4), [
          [_vShow, cardPreviewDisplayed.value]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})